module.exports = __webpack_public_path__ + "img/30.9.TU.0f7bd87a.png";